<app-reactive-dialog-content [data]="dialogInputData">
  <div>
    Polizze: {{ data.polizzennummer | formatNumber:'polizze' }}
  </div>
  <app-upload-file [currentDocuments]="currentDocuments" [uploadFileCallback]="uploadFileCallback"
                   [withDragAndDrop] = "true"
                   [maxFilesAdded]="1" fabText="Dokument auswählen">
  </app-upload-file>
</app-reactive-dialog-content>
<mat-dialog-actions align="end">
  <app-basic-icon-button icon="add" (clickEvent)="submit()"
                         [disabled]="isSubmitDisabled">
    Dokument hochladen
  </app-basic-icon-button>
  <app-basic-icon-button icon="close" (clickEvent)="dialogRef.close()">
    Abbrechen
  </app-basic-icon-button>
</mat-dialog-actions>
